import { AxiosError } from 'axios';

import { remoteServerAxios, proxyServerAxios } from 'src/api/axios';
import { RequestPsychicParams, RequestPsychicParamsProxy } from 'types/objectTypes';

export const getRightPsychicsProxy = (requestParameters?: any) => proxyServerAxios
  .post('/psychics/right', requestParameters)
  .then((resp) => resp.data)
  .catch((e) => e);

export const getRightPsychics = (
  requestParams: RequestPsychicParams,
  customerId?: string,
  cookie?: string,
) => remoteServerAxios
  .post('psychics', requestParams, {
    params: { CustId: customerId },
    headers: { ...(cookie ? { cookie } : {}) },
  })
  .then((resp) => resp.data);

export const getPsychicProxy = (id: string) => proxyServerAxios
  .get(`/psychics/${id}`)
  .then((resp) => resp.data)
  .catch((e: AxiosError) => e);

export const getPsychic = (id: string) => remoteServerAxios
  .get(`/psychics/${id}`)
  .then((resp) => resp.data)
  .catch((e) => e);

export const searchPsychicByCriteriaProxy = (criteria: string) => proxyServerAxios
  .get('/psychics/search', { params: { criteria } })
  .then((resp) => resp.data)
  .catch((e: AxiosError) => { throw e.response; });

export const searchPsychicByCriteria = (criteria: string) => remoteServerAxios
  .post('psychics/search', { SearchText: criteria })
  .then((resp) => resp.data)
  .catch((e: AxiosError) => { throw e.response; });

export const getTestimonialsByExtIdProxy = (
  requestParams: RequestPsychicParamsProxy,
) => proxyServerAxios
  .post('psychics/testimonials', requestParams)
  .then((resp) => resp.data)
  .catch((e: AxiosError) => { throw e.response; });

export const getTestimonialsByExtId = (
  requestParams: RequestPsychicParams,
  cookie?: string,
) => remoteServerAxios
  .post('psychic/testimonialsbyexid', requestParams, {
    headers: { ...(cookie ? { cookie } : {}) },
  })
  .then((resp) => resp.data)
  .catch((e: AxiosError) => { throw e.response; });
